import { render } from "./ZoneLivreurModal.vue?vue&type=template&id=2dbdc5ee&ts=true"
import script from "./ZoneLivreurModal.vue?vue&type=script&lang=ts"
export * from "./ZoneLivreurModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__